module.exports = __webpack_public_path__ + "static/media/SmartShop_7-713w.4cf664fd.jpg";